import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { artemulkImages } from "../../data/artemulkContent";
import AboutUs from "../AboutUs/AboutUs";
import VisionMission from "./VisionMission";
import BranchesSection from "./BranchesSection";
import Back from "../common/Back";
import Call1 from "../Call1/Call1";
import Whatsapp1 from "../Whatsapp1/Whatsapp1";
import "./about.css";

const coverImg = artemulkImages.pageCover;

const About = () => {
  useEffect(() => {
    if (window.location.hash === "#subelerimiz") {
      const el = document.getElementById("subelerimiz");
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 300);
      }
    }
  }, []);

  const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };

  return (
    <>
      <Route component={ScrollToTop} />
      <section className="about">
        <Back name="Arte Mülk" title="Hakkımızda" cover={coverImg} />
        <div className="pt-12 px-[3%] md:px-[6%]">
          <AboutUs />
          <VisionMission />
          <BranchesSection />
        </div>
        <Call1 />
        <Whatsapp1 />
      </section>
    </>
  );
};

export default About;
